import {secured as axios } from "../../../../axios";

export class NotificationConfig {

    static findAll(page=1, limit=30){
        return axios.get('users/notification-config', {params: { page, limit }}).then( res => res.data)
    }

    static update( {id, email, push} ){
        return axios.patch(`users/notifications/${id}`, { emailActivated: email, pushActivated: push })
    }
}